<template>
  <div class="management">
    <div class="top">
      <div class="top-item">
        <div class="in-block icon-all">
          <div class="role-num">{{ totalCount }}</div>
          <div class="role-name">{{ $t("managementV2.all") }}</div>
        </div>
      </div>
      <div class="top-item">
        <div class="in-block icon-4">
          <div class="role-num">{{ adminNum }}</div>
          <div class="role-name">
            {{ $i18n.locale === "zh" ? "管理员" : $roleCase[6] }}
          </div>
        </div>
      </div>
      <div class="top-item">
        <div class="in-block icon-0">
          <div class="role-num">{{ projectManagerNum }}</div>
          <div class="role-name">
            {{ $i18n.locale === "zh" ? "项目经理" : $roleCase[2] }}
          </div>
        </div>
      </div>
      <div class="top-item">
        <div class="in-block icon-1">
          <div class="role-num">{{ resourceManagerNum }}</div>
          <div class="role-name">
            {{ $i18n.locale === "zh" ? "资源经理" : $roleCase[3] }}
          </div>
        </div>
      </div>
      <div class="top-item">
        <div class="in-block icon-2">
          <div class="role-num">{{ reviserNum }}</div>
          <div class="role-name">
            {{ $i18n.locale === "zh" ? "审校" : $roleCase[5] }}
          </div>
        </div>
      </div>
      <div class="top-item">
        <div class="in-block icon-3">
          <div class="role-num">{{ translatorNum }}</div>
          <div class="role-name">
            {{ $i18n.locale === "zh" ? "译员" : $roleCase[4] }}
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="header">
        <div>
          <el-button
            type="primary"
            v-if="IS_PRIVATE || IS_ONLINE_PRIVATE"
            @click="handleAdd"
          >
            {{ $t("managementV2.add") }}</el-button
          >
          <el-button type="primary" v-else @click="handleInviteAdd">
            {{ $t("managementV2.invite")
            }}<i class="el-icon-circle-plus el-icon--right"></i>
          </el-button>
          <el-button type="primary" v-if="isBatchAdd" @click="handleBatchAdd">
            {{ $t("managementV2.batchAdd") }}</el-button
          >
          <!-- v-if="isBatchAdd" -->
        </div>
        <div class="query">
          <!-- <el-input v-model.trim="query.filter.aliasName" @keyup.enter.native="search" @clear="clearSearch" clearable :placeholder="$t('managementV2.searchName')"></el-input> -->
          <!-- <el-input v-model.trim="query.filter.aliasName" @keyup.enter.native="search"
                    @clear="clearSearch" clearable
                    :placeholder="$t('managementV2.searchNamePhoneEmail')"></el-input> -->
          <el-input
            v-model.trim="query.filter.aliasName"
            @keyup.enter.native="search"
            @clear="clearSearch"
            clearable
            :placeholder="
              IS_PRIVATE || IS_ONLINE_PRIVATE
                ? $t('managementV2.searchNames')
                : $t('managementV2.searchNamePhoneEmail')
            "
          ></el-input>
          <el-button type="primary" slot="append" @click="search"
            >{{ $t("common.query") }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          height="100%"
          border
          :data="managementList"
          @sort-change="sortChange"
          header-row-class-name="customHeader"
        >
          <el-table-column
            width="72"
            :label="$t('managementV2.number')"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="{ $index }">
              {{ $index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="aliasName"
            :label="$t('managementV2.name')"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              {{ showName(row) }}
            </template>
          </el-table-column>

          <!-- 独立部署显示为邮箱，飞译都显示 -->
          <el-table-column
            prop="loginPhone"
            :label="$t('managementV2.phone')"
            align="center"
            show-overflow-tooltip
            v-if="!(IS_PRIVATE || IS_ONLINE_PRIVATE)"
          >
            <template slot-scope="{ row }">
              {{ row.loginPhone || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            :label="$t('managementV2.email')"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              {{ row.email || "--" }}
            </template>
          </el-table-column>
          <!-- 结束 -->

          <el-table-column
            :label="$t('managementV2.role')"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              {{
                $i18n.locale === "zh" ? row.roleName : $roleCase[row.roleType]
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('managementV2.createtime')"
            align="center"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="status"
            :label="$t('managementV2.state')"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.roleLevel === 0">
                <p>--</p>
              </div>
              <div v-else>{{ getStatus(scope.row.status) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('managementV2.operation')"
            align="center"
            class-name="operate"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="$t('managementV2.edit')"
                placement="top"
                v-if="
                  ((scope.row.status == 1 &&
                    scope.row.roleLevel > teamRoleLevel) ||
                    teamRoleLevel == 0) &&
                  (IS_PRIVATE || IS_ONLINE_PRIVATE)
                "
              >
                <i class="icon-edit" @click="handleEdit(scope.row)"></i>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                :content="$t('managementV2.edit')"
                placement="top"
                v-else-if="
                  (scope.row.status == 1 &&
                    scope.row.roleLevel > teamRoleLevel) ||
                  teamRoleLevel == 0
                "
              >
                <i class="icon-edit" @click="handleEditUser(scope.row)"></i>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                :content="$t('managementV2.cancelInvitation')"
                placement="top"
                v-if="
                  scope.row.status == 2 && scope.row.roleLevel > teamRoleLevel
                "
              >
                <i class="icon-invite" @click="disinvite(scope.row)"></i>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                :content="$t('managementV2.inviteAgain')"
                placement="top"
                v-if="
                  [3, 4].includes(scope.row.status) &&
                  scope.row.roleLevel > teamRoleLevel
                "
              >
                <i class="icon-inviteAgain" @click="inviteAgain(scope.row)"></i>
              </el-tooltip>

              <el-tooltip
                v-if="
                  scope.row.roleLevel > teamRoleLevel && scope.row.status != 2
                "
                effect="dark"
                :content="$t('managementV2.delete')"
                placement="top"
              >
                <i class="icon-delete" @click="handleDelete(scope.row.id)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :total="totalRows"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="query.page"
          :page-size="query.rows"
          :page-sizes="[10, 20, 30, 40]"
          layout="prev, pager, next, sizes"
        >
        </el-pagination>
      </div>
    </div>
    <deleteUser
      :deleteState="deleteShow"
      :delUserId="delUser"
      @deleteShow="deleteClose"
      @updateData="updateData"
    >
    </deleteUser>
    <addUser
      :roleId="roleList"
      :exhibition="addVisible"
      @childByval="addClose"
      @sendInvitationsMembers="sendInvitationsMembers"
    >
    </addUser>
    <editUser
      :editState="editVisible"
      :roleId="roleList"
      :editData="editData"
      @edithiden="editClose"
      @editSure="editOk"
    >
    </editUser>
    <BatchAddUser
      :roleList="roleList"
      :batchAddVisible="batchAddVisible"
      @batchAddCancel="batchAddCancel"
      @updateTeamList="updateTeamList"
    >
    </BatchAddUser>
    <InviteUser
      :roleList="roleList"
      :inviteAddVisible="inviteAddVisible"
      @handleCancel="inviteAddCancel"
      @updateTeamList="updateTeamList"
    >
    </InviteUser>
    <NewEditUser
      :editUserVisible="editUserVisible"
      :roleList="roleList"
      :editData="editData"
      @handleCancel="handleEditUserCancel"
      @updateTeamList="updateTeamList"
    >
    </NewEditUser>
  </div>
</template>

<script>
import {
  teamNumber,
  queryManagementPage,
  getRoleList,
  inviteMembers,
  inviteMembersByPhone,
  editUsers,
  disinvitation,
  disinvitationByPhone,
} from "@/services/teamManagement";

import addUser from "@/components/layer/addUser/index.vue";
import editUser from "@/components/layer/editUser/index.vue";
import deleteUser from "@/components/layer/deleteUser/index.vue";
import InviteUser from "@/components/layer/userManageDialog/inviteUser";
import NewEditUser from "@/components/layer/userManageDialog/editUser";
import BatchAddUser from "@/components/layer/batchAddUser/index.vue";
import { mapState } from "vuex";

export default {
  name: "management",
  beforeRouteEnter(to, from, next) {
    if (from.name == null) {
      console.log("刷新进入");
      next((vm) => {
        vm.isRefushGoing = true;
      });
    }else{
      next((vm) => {
        vm.isRefushGoing = false;
      });
    }
  },
  components: {
    addUser,
    editUser,
    InviteUser,
    deleteUser,
    BatchAddUser,
    NewEditUser,
  },
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE, // 是否为独立部署
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      haveClass: haveClass, // 是否为独立部署
      managementList: [],
      query: {
        filter: {
          aliasName: "",
        },
        page: 1,
        rows: 10,
        sort: {
          // createTime: '',
        },
      },
      totalRows: 0,
      deleteShow: false,
      addVisible: false,
      editVisible: false,
      batchAddVisible: false,
      delUser: 0,
      roleList: [],
      editData: {},
      teamRoleLevel: null,
      teamNumList: [],
      totalCount: 0,
      adminNum: 0,
      projectManagerNum: 0,
      resourceManagerNum: 0,
      reviserNum: 0,
      translatorNum: 0,
      inviteAddVisible: false, // 邀请弹窗
      editUserVisible: false, // 新版编辑
      isRefushGoing:false,//刷新进入
    };
  },
  computed: {
    ...mapState("layout", ["userInfo",'navInfo']),
    // 独立部署的老师，批量添加按钮
    isBatchAdd() {
      return this.haveClass && this.userInfo.hasTeamBatchAdd;
    },
    identityType() {
      return [0, 2].includes(this.userInfo.identityType);
    },
  },
  watch:{
    navInfo:{
      deep:true,
      handler(newVal,oldVal){
        let url =newVal.find(item=>item.code == "team_manage").url
        if(this.isRefushGoing && url){
          this.isRefushGoing =false
          this.$router.replace({ path: url })
        }
      }
    }
  },
  mounted() {
    // 获取角色列表
    this.getRoleList();
    // 获取在其他团队权限
    this.getRoleLevel();
    // 获取页面
    this.getManagementPage();
    // 获取页面顶部数量
    this.getTeamNumber();
  },
  methods: {
    //姓名
    showName(row) {
      if (row.aliasName == row.nickName) {
        return row.aliasName;
      } else {
        if (row.nickName == null) {
          return row.aliasName;
        } else {
          return `${row.aliasName}(${row.nickName})`;
        }
      }
    },
    updateTeamList() {
      this.getManagementPage();
      this.getTeamNumber();
    },
    handleBatchAdd() {
      this.batchAddVisible = true;
    },
    batchAddCancel() {
      this.batchAddVisible = false;
    },
    inviteAddCancel() {
      this.inviteAddVisible = false;
    },
    async getManagementPage() {
      let { list, status, success, totalRows } = await queryManagementPage(
        this.query
      );
      if (success && status === 200) {
        this.managementList = list;
        this.totalRows = totalRows;
        //删除优化
        if (this.query.page > 1 && list.length == 0) {
          this.query.page--;
          this.getManagementPage();
        }
      }
    },
    //获取当前账户下的角色
    async getRoleList() {
      let params = {
        companyCode: this.companyCode,
      };
      const res = await getRoleList(params);
      if (res.status == 200 && res.success) {
        this.roleList = res.result;
      }
    },
    async editOk(val) {
      const res = await editUsers(val);
      if (res.resultCode == 1 && res.success) {
        this.getTeamNumber();
        this.getManagementPage();
        this.editVisible = false;
        this.$message.success(this.$t("managementV2.userSuccessed"));
      }
    },
    async disinvite(row) {
      let params = {
        // loginPhone: row.loginPhone,
        id: row.id,
      };
      let res = {};
      // 独立部署为邮箱，飞译为手机号
      if (!(this.IS_PRIVATE || this.IS_ONLINE_PRIVATE)) {
        params.loginPhone = row.loginPhone;
        res = await disinvitationByPhone(params);
      } else {
        params.email = row.email;
        res = await disinvitation(params);
      }
      if (res.success && res.status == 200) {
        this.getManagementPage();
        this.$message.closeAll();
        this.$message.success(
          this.$t("managementV2.invitationCancelledSuccessfully")
        );
      } else {
        this.$message.closeAll();
        this.$message.error(res.errorDesc);
      }
    },
    async inviteAgain(row) {
      let params = {
        aliasName: row.aliasName,
        // loginPhone: row.loginPhone,
        roleId: row.roleId,
        roleName: row.roleName,
        resourceIds: row.resourceIdList,
      };
      let res = {};
      if (!(this.IS_PRIVATE || this.IS_ONLINE_PRIVATE)) {
        params.loginPhone = row.loginPhone;
        res = await inviteMembersByPhone(params);
      } else {
        // 私有化部署不需要同意直接加入
        params.email = row.email;
        res = await inviteMembers(params);
      }
      if (res.success && res.status == 200) {
        this.getManagementPage();
        this.$message.closeAll();
        this.$message.success(this.$t("managementV2.invitationSentAgain"));
      } else {
        this.$message.closeAll();
        this.$message.error(res.errorDesc);
      }
    },
    //邀请成员
    async sendInvitationsMembers(data) {
      let params = {
        aliasName: data.name,
        roleId: data.roleId,
        roleName: data.roleName,
        resourceIds: data.id,
      };
      this.addVisible = false;
      // let res = {}
      // if (!(this.IS_PRIVATE || this.IS_ONLINE_PRIVATE)) {
      //   params.loginPhone = data.loginPhone;
      //   res = await inviteMembersByPhone(params);
      // } else {
      // params.email = data.email;
      data.loginPhone && (params.loginPhone = data.loginPhone);
      data.email && (params.email = data.email);
      // 老师和校领导添加不需要同意
      if (
        [1, 3].includes(
          JSON.parse(localStorage.getItem("userInfo")).identityType
        )
      ) {
        params.needAgree = false;
      }
      const res = await inviteMembers(params);
      // }
      if (res.success && res.status == 200) {
        this.query.page = 1;
        this.updateTeamList();
        this.$message.closeAll();
        if (!(this.IS_PRIVATE || this.IS_ONLINE_PRIVATE)) {
          this.$message.success(this.$t("managementV2.invitationSent"));
        } else {
          this.$message.success(this.$t("managementV2.useraddSuccessed"));
        }
      }
    },
    async getTeamNumber() {
      const { status, success, result } = await teamNumber({});
      if (status == 200 && success) {
        // 去掉超级管理员
        this.totalCount = 0;
        this.teamNumList = result.filter((item) => item.roleType !== 1);
        this.teamNumList.forEach((item) => {
          if (item.roleType === 2) {
            this.projectManagerNum = item.count;
          } else if (item.roleType === 3) {
            this.resourceManagerNum = item.count;
          } else if (item.roleType === 5) {
            this.reviserNum = item.count;
          } else if (item.roleType === 4) {
            this.translatorNum = item.count;
          } else if (item.roleType === 6) {
            this.adminNum = item.count;
          }
          this.totalCount += item.count;
        });
      }
    },
    sortChange({ prop, order }) {
      if (order == "descending") {
        this.query.sort.createTime = "desc";
      } else if (order == "ascending") {
        this.query.sort.createTime = "asc";
      } else if (order === null) {
        this.query.sort = {};
      }
      if (prop === "createTime") {
        this.getManagementPage();
      }
    },
    getStatus(row) {
      switch (row) {
        case 1:
          return this.$t("managementV2.joined");
        case 2:
          return this.$t("managementV2.inInvitation");
        case 3:
          return this.$t("managementV2.cancelInvitation");
        case 4:
          return this.$t("managementV2.rejected");
      }
    },
    search() {
      this.query.page = 1;
      this.getManagementPage();
    },
    clearSearch() {
      this.query.page = 1;
      this.query.filter.aliasName = "";
      this.getManagementPage();
    },
    // 页码大小变化
    handleSizeChange(val) {
      this.query.rows = val;
      this.getManagementPage();
    },
    // 选中页码变化
    handleCurrentChange(val) {
      this.query.page = val;
      this.getManagementPage();
    },
    handleEdit(date) {
      this.editVisible = true;
      this.editData = { ...date };
    },
    handleEditUser(user) {
      this.editUserVisible = true;
      this.editData = { ...user };
    },
    handleEditUserCancel() {
      this.editUserVisible = false;
    },
    handleDelete(id) {
      this.delUser = id;
      this.deleteShow = true;
    },
    deleteClose() {
      this.deleteShow = false;
    },
    handleAdd() {
      this.addVisible = true;
    },
    handleInviteAdd() {
      this.inviteAddVisible = true;
    },
    addClose() {
      this.addVisible = false;
    },
    editClose() {
      this.editVisible = false;
    },
    updateData() {
      this.getManagementPage();
      this.getTeamNumber();
    },
    //获取在其他团队的权限
    getRoleLevel() {
      let allTeam = JSON.parse(localStorage.getItem("userInfo")).companyList;
      let team = allTeam.filter((val) => {
        return (
          val.code ===
          (localStorage.getItem("companyCode") ||
            localStorage.getItem("myCompanyCode"))
        );
      });
      this.teamRoleLevel = team[0].role.roleLevel;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
<style>
@media screen and (max-width: 1480px) {
  .management .in-block {
    padding-left: 52px !important;
  }
}
</style>